import { LeftOutlined, PlusOutlined, RightOutlined } from "@ant-design/icons";
import { Carousel } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import product from "../../assets/product.png";
import heart from "../../assets/heart.png";
import "../../styles/products.css";
import { useTranslation } from "react-i18next";

const TopPicks = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div className="bg-[#FCFBFA] mt-20 mb-10 px-20 max-lg:px-5 pt-14 pb-8 products">
      <div className="lg:flex items-start justify-between">
        <div>
          <h3 className="text-[#14294F] text-2xl font-semibold">
            {t("Top Picks For You")}
          </h3>
          <p className="text-[#737E91] text-lg mt-3 w-5/6 max-lg:w-full">
            {t("Discover the latest arrivals at Samoolah shop based on your preferences, handpicked just for you.")}
          </p>
        </div>
        <div>
          <Link
            to="/store"
            className="text-[#FE9B71] rounded-full border-4 border-[#FE9B71] w-[200px] h-[50px] text-xl flex items-center justify-center font-semibold max-lg:mt-5"
          >
            {language == "en" ? (
            <>
              {t("Shop Now")}
              <RightOutlined className="ml-8 max-lg:ml-2 font-bold" />
            </>
          ) : (
            <>
              {t("Shop Now")}
              <LeftOutlined className="mr-8 max-lg:mr-2 font-bold" />
            </>
          )}

          </Link>
        </div>
      </div>

      <Carousel arrows infinite={false} className="my-9">
        <div>
          <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-4 lg:items-center w-3/4 mx-auto">
            <div className="mx-auto flex justify-center">
              <div className="relative">
                <img
                  src={product}
                  className="rounded-3xl w-[350px] h-[280px] mx-auto"
                />
                <div className="bg-[#FCFBFA] w-[50px] h-[50px] mx-auto flex items-center rounded-full absolute top-5 right-8">
                  <img
                    src={heart}
                    className="text-[#fe6625] mx-auto w-[22px]"
                  />
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-[#283D63] text-2xl font-semibold">
                Cage Lamp
              </h3>
              <p className="text-[#737E91] text-lg mt-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Ut........
              </p>
              <div className="mt-4 flex items-center">
                <button className="bg-[#19161B] border-2 border-[#FE6625] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#ECEBEC] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#94BEEF] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#153C6A] w-[45px] h-[35px] rounded-lg mr-3"></button>
              </div>
              <div className="lg:flex items-center justify-between px-3 mt-4">
                <div>
                  <p className="text-[#606D84] font-semibold text-xl">
                    1546 SR
                  </p>
                </div>
                <button className="bg-[#FE9B71] text-white flex items-center px-5 py-2 text-xl rounded-full font-semibold max-lg:mt-4">
                  Add <PlusOutlined className="ml-4" />
                </button>
                <div>
                  <Link
                    to="/"
                    className="text-[#FE9B71] rounded-full border-2 border-[#FE9B71] px-5 py-2 text-xl flex items-center justify-center font-semibold max-lg:mt-4"
                  >
                    View details
                    <RightOutlined className="ml-3 font-bold" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>2</div>
        <div>3</div>
      </Carousel>
    </div>
  );
};

export default TopPicks;
